import React from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import SearchLoadTable from 'components/common/SearchLoadingTable';
import { activeListingsSubColumns, subColumnsLoading } from 'utils/table/tableColumns';
import { appendSizeUnitAndSingleGender } from 'utils/table/tableUtils';

export const ExpandedRowTable = ({ tableData, columns, order }) => {
  const nestedTableSettings = useSelector((state) => get('search.nestedTable')(state));

  const data = appendSizeUnitAndSingleGender(order, tableData);

  return (
    <div>
      {nestedTableSettings.pending && nestedTableSettings.currentPT === order.id ? (
        <SearchLoadTable columns={subColumnsLoading} pagination={false} sub />
      ) : (
        <Table dataSource={data} columns={columns || activeListingsSubColumns} pagination={false} />
      )}
    </div>
  );
};

ExpandedRowTable.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      dataIndex: PropTypes.string,
      key: PropTypes.string,
    }),
  ),
  tableData: PropTypes.arrayOf(
    PropTypes.shape({
      quantity: PropTypes.number,
    }),
  ),
  order: PropTypes.shape({
    id: PropTypes.number,
  }),
};

export default ExpandedRowTable;
